module.exports = __webpack_public_path__ + "img/flower_leaf_11.45c52a2e.png";